import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("fj_admin_token");
    if (!token) return setUser(false);
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => { localStorage.removeItem("fj_admin_token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("fj_admin_token", data.token);
    setUser(data.user);
  };
  const logout = () => { localStorage.removeItem("fj_admin_token"); setUser(false); };

  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
};

export const useAdminAuth = () => useContext(Ctx);
